import React from 'react';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-[85vh] md:h-[90vh] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="/images/Weboldalképei/513502099_23889229397400221_4984633965961444247_n.jpg"
          alt="XL bútor műhely"
          className="w-full h-full object-cover"
          loading="eager"
        />
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/30 to-black/60" />
      </div>

      {/* Content */}
      <div className="relative h-full mx-auto max-w-[var(--container-max)] px-4 flex items-center">
        <div className="max-w-3xl">
          <div>
            <h1 className="text-white font-[var(--font-serif)] text-[42px] md:text-[56px] leading-[1.1] tracking-tight font-semibold mb-6">
              Egyedi bútor, precíz kivitelezéssel{' '}
              <span className="text-[var(--color-accent)]">1989 óta</span>
            </h1>
          </div>

          <p className="text-white/90 text-lg md:text-xl leading-relaxed mb-8 max-w-2xl">
            3D tervezéstől a kivitelezésig – minden egyedi bútor a saját 1500 m² asztalos műhelyünkben készül, maximális testreszabással.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/works"
              className="px-8 py-4 bg-[var(--color-accent)] text-white font-semibold rounded-lg transition-colors duration-200 shadow-lg text-center active:scale-95"
            >
              Munkáink megtekintése
            </Link>
            <Link
              to="/contact"
              className="px-8 py-4 bg-transparent text-white font-semibold rounded-lg border-2 border-white transition-colors duration-200 text-center active:scale-95"
            >
              Ajánlatkérés
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll Indicator - Hidden on mobile for better performance */}
      <div className="hidden md:block absolute bottom-8 left-1/2 -translate-x-1/2">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-1.5 bg-white rounded-full" />
        </div>
      </div>
    </section>
  );
}

